<template>
  <div class="content">
    <router-view />
  </div>
  
  <div class="bottom-nav">
    <router-link to="/home" class="nav-item" active-class="active">
      <div class="icon">🏠</div>
      <div class="text">首页</div>
    </router-link>
    <router-link to="/device" class="nav-item" active-class="active">
      <div class="icon">⚙️</div>
      <div class="text">设备</div>
    </router-link>
    <router-link to="/community" class="nav-item" active-class="active">
      <div class="icon">👥</div>
      <div class="text">社区</div>
    </router-link>
    <router-link to="/mine" class="nav-item" active-class="active">
      <div class="icon">👤</div>
      <div class="text">我的</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2C2C2A;
}
.content {
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom: 50px;
  overflow: auto;
}
.bottom-nav {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #5f5e5a;
  text-decoration: none;
  font-size: 12px;
}

.nav-item.active {
  color: #0F6E56;
}

.icon {
  font-size: 20px;
  margin-bottom: 2px;
}

.text {
  font-size: 12px;
}

/* 适配手机端 */
@media (max-width: 768px) {
  .bottom-nav {
    height: 60px;
  }
  
  .icon {
    font-size: 24px;
  }
  
  .text {
    font-size: 14px;
  }
}
</style>